import { productionOrderSheetFieldsSchema } from '@repo/api-contracts';

/** 발주서 입력을 저장 전에 검사해 첫 문제를 한국어로 돌려준다 — 문제가 없으면 null. */
export const sheetInputMessage = (values: unknown): string | null => {
  const result = productionOrderSheetFieldsSchema.safeParse(values);
  if (result.success) return null;
  const issue = result.error.issues[0];
  if (!issue) return '입력 내용을 확인해 주세요.';
  const [scope, index, field] = issue.path;
  if (scope === 'lines' && typeof index === 'number') {
    const row = ` (${index + 1}행)`;
    if (field === 'name')
      return issue.code === 'too_big'
        ? `품목명은 100자 이내로 입력해 주세요.${row}`
        : `품목명을 입력해 주세요.${row}`;
    if (field === 'unitPrice') return `단가는 0 이상의 정수로 입력해 주세요.${row}`;
    if (field === 'quantity') return `수량은 1 이상의 정수로 입력해 주세요.${row}`;
  }
  return '입력 내용을 확인해 주세요.';
};
